import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PageNotFoundComponent } from './components/pagenotfound/pagenotfound.component';
import { ForbiddenComponent } from './components/forbidden/forbidden.component';

const appRoutes: Routes = [
    {
        path: '',
        loadChildren: () => import('./app-public/app-public.module').then(m => m.AppPublicModule)
    },
    {
        path: 'app',
        loadChildren: () => import('./app-private/app-private.module').then(m => m.AppPrivateModule)
    },
    { path: 'forbidden', component: ForbiddenComponent, data: { title: 'Forbidden' } },
    { path: '**', component: PageNotFoundComponent, data: { title: 'Page not found' } }
];

export const routes: ModuleWithProviders = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./ClientApp/app/app-routing.module.ts